// Global components
import Vue from 'vue';

import ContentPlaceholder from './ContentPlaceholder';
import PageHeading from './PageHeading';
import ErrorBlock from './ErrorBlock';
import ElCard from './ElCard';
import ElCollapseItem from './ElCollapseItem';

Vue.component('contentPlaceholder', ContentPlaceholder);
Vue.component('pageHeading', PageHeading);
Vue.component('errorBlock', ErrorBlock);
Vue.component('elCard', ElCard);
Vue.component('elCollapseItemCustom', ElCollapseItem);



// WEBPACK FOOTER //
// ./src/components/index.js